import React from 'react';
import { Box } from '@mui/material';
import { PETROSOFT_BEARER_TOKEN } from '../../constants/urls';

const ADMIN_TER_SCHEME_URL = process.env.REACT_APP_ADMIN_TER_SCHEME_URL;

export default function AdminTerSchemePage() {
  return (
    <Box sx={{ width: '100%', height: '100%', pt: 3 }}>
      <Box
        sx={{ width: '100%', height: '100%' }}
        component="iframe"
        title="ter_scheme"
        src={`${ADMIN_TER_SCHEME_URL}/operator-ui/?aistoken=${PETROSOFT_BEARER_TOKEN}#template/3913`}
      />
    </Box>
  );
}
